/**
 * <Msg k="…" args={{ link: <Link …>{t('…')}</Link> }} />: a catalog message whose string arguments are React nodes
 * (links, emphasis), so a translation can put them anywhere in the sentence (#799).
 */
import { Fragment, createElement, type ReactNode } from 'react';
import { tPieces, type MessageKey, type RichArgs } from './i18n';
import { useT } from './useT';

export default function Msg<K extends MessageKey>({ k, args }: { k: K; args: RichArgs<K> }) {
  useT();
  // Variadic children need no keys.
  return createElement(Fragment, null, ...(tPieces(k, args) as ReactNode[]));
}
